"use client";

import { ProductCard } from "./ProductCard";
import { WooCommerceProduct } from "@/types/woocommerce";
import { Spinner } from "@nextui-org/react";

interface ProductGridProps {
  products: WooCommerceProduct[];
  loading: boolean;
  error: string | null;
  initialLoad?: boolean;
}

export function ProductGrid({ products, loading, error, initialLoad = false }: ProductGridProps) {
  if (initialLoad) {
    return (
      <div className="flex items-center justify-center py-20">
        <Spinner size="lg" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center py-20 text-center">
        <div className="text-danger text-lg font-semibold mb-2">Error Loading Products</div>
        <p className="text-gray-600">{error}</p>
      </div>
    );
  }

  if (products.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-20 text-center">
        <div className="text-xl font-semibold mb-2">No Products Found</div>
        <p className="text-gray-600">Try adjusting your filters to see more products.</p>
      </div>
    );
  }

  return (
    <div>
      <div className="mb-4 text-sm text-gray-600 flex items-center gap-2">
        Showing <span className="font-semibold">{products.length}</span> products
        {loading && (
          <Spinner size="sm" color="primary" />
        )}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {products.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
    </div>
  );
}
